import $ from 'jquery'

export default function playOnHoverDirective(context=document.body) {
    const $element = $(context).find('[sw-play-on-hover]');

    $element.each(function() {
        const $this = $(this);
        const $videos = $this.find('video');

        $this.on('mouseenter', function() {
            $videos.each(function() {
                if (!this.ended || this.loop) {
                    this.play();
                }
            });
        })
        .on('mouseleave', function() {
            $videos.each(function() {
                this.pause();
            });
        });
    });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/play-on-hover.js